import { ref, onMounted, onBeforeUnmount } from "vue";

export default function useScrollHide(threshold = 50) {
  const isHidden = ref(false);
  const lastScrollPos = ref(0);

  const handleScroll = () => {
    const currentScrollPos =
      window.pageYOffset || document.documentElement.scrollTop;

    if (Math.abs(currentScrollPos - lastScrollPos.value) < threshold) {
      return;
    }

    isHidden.value =
      currentScrollPos > lastScrollPos.value && currentScrollPos > 100;
    lastScrollPos.value = currentScrollPos;
  };

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("scroll", handleScroll);
  });

  return { isHidden };
}
